import React from "react";
import { Typography } from "@mui/material";

const Privacy = () => {
  return (
    <div style={styles.div}>
      <Typography variant="h2">Politique de Confidentialité</Typography>

      <h3>Définition et nature des données personnelles</h3>

      <p>
        Lors de l'utilisation de l'application mobile "GeoFlag" (ci-après:
        "l'Application" ou "l'Application"), nous pouvons vous demander de nous
        fournir des données personnelles vous concernant, afin d'utiliser les
        services proposés (ci-après : les services"). Dans le cadre de cette
        politique, le terme «données personnelles» désigne l'ensemble des
        données permettant l'identification d'une personne physique, qui
        correspondent notamment à vos nom et prénom, sexe, taille, poids,
        allergies, ville de résidence, e -mail, numéro de téléphone, prénom, nom
        et numéro de téléphone du contact d'urgence que vous avez fourni, ainsi
        que toute autre information que vous choisissez de nous communiquer à
        votre sujet.
      </p>

      <h3>Objectif de cette politique</h3>

      <p>
        Le but de cette politique est de vous informer sur les moyens que nous
        utilisons pour collecter vos données personnelles, dans le strict
        respect de vos droits. A ce titre, nous vous informons que nous nous
        conformons, dans la collecte et la gestion de vos données personnelles,
        à la loi n ° 78-17 du 6 janvier 1978 relative à l'informatique, aux
        fichiers et aux libertés, dans sa version actuelle, dite " Informatique
        et Libertés "(Loi Informatique et Libertés), et Règlement (UE) 2016/679
        du 27 avril 2016 (ci-après:" RGPD ").
      </p>

      <h3>Identité du collecteur de données</h3>

      <p>
        Le responsable de la collecte de vos données personnelles est Normit,
        société SASU, immatriculée en France au Registre du Commerce et des
        Sociétés de Caen sous le numéro 949063978.
      </p>

      <h3>Collecte de données personnelles</h3>
      <p>
        Nous recueillons des informations vous concernant, y compris des
        informations qui vous identifient directement, via la section profil de
        l'application. Lors de la collecte de vos données personnelles, nous
        vous informons si certaines données sont obligatoires ou facultatives.
        Les données obligatoires sont nécessaires au fonctionnement des
        Services. Vous êtes libre de choisir de fournir ou non des données
        facultatives. Nous vous indiquons également les conséquences possibles
        de ne pas répondre. Les informations que nous recueillons auprès de vous
        sont les suivantes:
        <ul>
          <li>Pseudo</li>
          <li>Photo de profil</li>
          <li>Adresse email de connexion</li>
        </ul>
        <p>
          Les informations que nous demandons seront uniquement détenues par
          nous et utilisées comme décrit dans ce document. L'application utilise
          des services tiers qui peuvent collecter des informations
          personnellement identifiables. Nous vous invitons à aller consulter
          leurs politiques de Confidentialité également. En voici la liste :
        </p>
        <ul>
          <li>Google</li>
          <li>Apple</li>
          <li>Adresse email de connexion</li>
        </ul>
      </p>

      <h3>Information de Lieu</h3>

      <p>
        Nous collectons et traitons les informations de localisation lorsque
        vous vous inscrivez et utilisez les Services. Nous ne suivons pas
        l'emplacement de votre appareil lorsque vous n'utilisez pas
        l'application, mais afin de fournir les services de base de
        l'application, il nous est nécessaire de suivre l'emplacement de votre
        appareil pendant que vous utilisez l'application. Ces informations de
        localisation ne sont jamais enregistrées ou partagées avec des tiers.
      </p>

      <h3>Comment l'application utilise les informations</h3>
      <ul>
        <li>
          Pour fournir les Services: Afin de permettre à l'application de savoir
          si vous vous trouvez au bon endroit pour continuer le parcours.
        </li>
      </ul>

      <h3>Liens vers d'autres sites</h3>

      <p>
        Ce service peut contenir des liens vers d'autres sites. Si vous cliquez
        sur un lien tiers, vous serez dirigé vers ce site. Notez que ces sites
        externes ne sont pas exploités par nous. Par conséquent, nous vous
        conseillons vivement de consulter la politique de confidentialité de ces
        sites Web. Nous n'avons aucun contrôle et n'assumons aucune
        responsabilité pour le contenu, les politiques de confidentialité ou les
        pratiques de tout site ou service tiers.
      </p>

      <h3>Transfert de données personnelles</h3>

      <p>
        Nous ne vendons, ne louons ni ne partageons vos informations
        personnelles. L'Application peut regrouper les informations que vous et
        d'autres personnes rendez disponibles en relation avec les Services et
        les publier publiquement ou les partager avec des tiers.
      </p>

      <h3>Durée de stockage</h3>

      <p>
        Nous conservons les informations aussi longtemps que nécessaire pour
        vous fournir les Services, sous réserve de toute obligation légale de
        conserver davantage ces informations. Les informations associées à votre
        compte seront généralement conservées jusqu'à ce qu'il ne soit plus
        nécessaire de fournir les Services ou jusqu'à ce que votre compte soit
        supprimé. De plus, vous pouvez supprimer certains éléments d'information
        (par exemple, les informations de profil) sans supprimer votre compte.
      </p>

      <h3>Protection de vos informations</h3>
      <p>
        Nous apprécions votre confiance en nous fournissant vos informations
        personnelles, c'est pourquoi nous nous efforçons d'utiliser des moyens
        commercialement acceptables pour les protéger. Mais rappelez-vous
        qu'aucune méthode de transmission sur Internet, ni aucune méthode de
        stockage électronique n'est sûre et fiable à 100%, et nous ne pouvons
        garantir sa sécurité absolue.
      </p>

      <h3>Accès à vos données personnelles</h3>

      <p>
        Conformément à la loi n ° 78-17 du 6 janvier 1978 relative à
        l'informatique, aux fichiers et aux libertés, et au RGPD, vous avez le
        droit d'obtenir la communication et, le cas échéant, la rectification ou
        l'effacement des données concernant vous, en vous adressant à: Adresse
        e-mail: founders@mile.eu.com Adresse postale: Mile Positioning Solutions
        - 390 Che du Mas Joint 69270 FONTAINES SAINT MARTIN - France. Il est
        rappelé que toute personne peut, pour des motifs légitimes, s'opposer au
        traitement des données la concernant. Cependant, nous pouvons continuer
        le traitement s'il existe des raisons légitimes de traitement qui
        prévalent sur vos droits et libertés ou si le traitement est nécessaire
        pour établir, exercer ou défendre nos droits légaux.
      </p>

      <h3>Portabilité de vos données personnelles</h3>
      <p>
        Vous avez le droit à la portabilité des données personnelles que vous
        nous avez fournies, entendues comme des données que vous avez activement
        et consciemment déclarées dans le cadre de l'accès et de l'utilisation
        des services. Nous vous rappelons que ce droit ne s'applique pas aux
        données collectées et traitées sur une base légale autre que le
        consentement ou l'exécution du contrat nous liant. Ce droit peut être
        exercé gratuitement, à tout moment, et notamment lors de la fermeture de
        votre compte sur l'Application, afin de récupérer et de conserver vos
        données personnelles. Dans ce cadre, nous vous adresserons vos données
        personnelles, par tout moyen jugé utile, dans un format standard ouvert
        couramment utilisé et lisible par machine, conformément à l'état de la
        technique.
      </p>

      <h3>Déposer une plainte auprès d'une autorité de contrôle</h3>

      <p>
        Vous êtes également informé que vous avez le droit d'introduire une
        réclamation auprès d'une autorité de contrôle compétente (la Commission
        Nationale Informatique et Libertés pour la France), dans l'État membre
        dans lequel vous résidez normalement, où vous travaillez ou où la
        violation de vos droits aurait été commis, si vous considérez que le
        traitement de vos données personnelles faisant l'objet de la présente
        charte constitue une violation des lois applicables. Ce recours peut
        être exercé sans préjudice de tout autre recours devant un tribunal
        administratif ou judiciaire. En effet, vous disposez également d'un
        droit à un recours administratif ou judiciaire effectif si vous estimez
        que le traitement de vos données personnelles faisant l'objet de la
        présente charte constitue une violation des textes applicables.
      </p>

      <h3>Limitation du traitement</h3>
      <p>
        Vous avez le droit d'obtenir la limitation du traitement de vos données
        personnelles, dans les cas suivants: Pendant la période de vérification
        que nous effectuons, lorsque vous contestez l'exactitude de vos données
        personnelles, Lorsque le traitement de vos données personnelles est
        illicite et que vous souhaitez restreindre le traitement plutôt que
        supprimer vos données, Lorsque nous n'avons plus besoin de vos données
        personnelles, mais que vous souhaitez les conserver pour exercer vos
        droits, Pendant la période de vérification des motifs légitimes, lorsque
        vous vous êtes opposé au traitement de vos données personnelles.
      </p>

      <h3>Changements</h3>
      <p>
        Nous pouvons mettre à jour notre politique de confidentialité de temps à
        autre. Ainsi, il vous est conseillé de revoir cette page périodiquement
        pour tout changement. Nous vous informerons de tout changement en
        publiant la nouvelle politique de confidentialité sur cette page.
      </p>

      <h3>Nous contacter</h3>

      <p>
        Si vous avez des questions ou des suggestions concernant notre politique
        de confidentialité, n'hésitez pas à nous contacter à
        normit.pro@gmail.com
      </p>
    </div>
  );
};

export default Privacy;

const styles = {
  div: {
    marginLeft: 5,
  },
};
